var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTeam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#275877"
    },
    cx: 256,
    cy: 53.632,
    r: 53.632
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#275877"
    },
    d: "M348.512,226.152v-47.464c0-49.976-54.544-50.888-54.544-50.888h-75.936 c0,0-54.544,0.608-54.544,50.888v47.472L348.512,226.152z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8db5b9"
    },
    cx: 392.287,
    cy: 339.46,
    r: 53.632
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8db5b9"
    },
    d: "M484.8,512v-47.496c0-49.976-54.544-50.888-54.544-50.888h-75.936c0,0-54.544,0.608-54.544,50.888 V512H484.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#06223f"
    },
    cx: 119.712,
    cy: 339.46,
    r: 53.632
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#06223f"
    },
    d: "M212.224,512v-47.488c0-49.977-54.544-50.888-54.544-50.888H81.752c0,0-54.552,0.608-54.552,50.888 V512H212.224z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTeam);
export default __webpack_public_path__ + "static/media/icon-team.1f5755da3f3fd24d0f9f0c9503590d8c.svg";
export { ForwardRef as ReactComponent };